import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { BackLink } from './Form/FormComponents';

import PartnerLogo from './PartnerLogo';
import { Disclaimer } from './Form/FormComponents';

import { copyFor } from '../../copy/copy';

const SidebarContainer = styled.div`
    flex: 0 1 32.37%;
    padding: 1em 0 1.375em 1em;
    display: flex;
    flex-direction: column;

    @media (max-width: 30em) {
        display: none;
    }
`;

const Title = styled.div`
    font-size: 20px;
    line-height: 1.4;
    color: #333;
    flex: 1;
`;

const Bold = styled.span`
    font-weight: bold;
    color: #000;
`;

const Amount = styled.span`
    font-weight: bold;
    color: #ff245e;
`;

const Sidebar = props => (
    <SidebarContainer>
        <PartnerLogo logoUrl={props.partnerLogo} onClick={props.onPartnerClick} />
        <Title>
            <Bold>Great choice!</Bold> <br /> You’ve selected to donate{' '}
            <Amount>{props.amount}.</Amount>
        </Title>
        <BackLink
            style={{ textAlign: 'left', marginBottom: '12px' }}
            hidden={!(props.hasChoiceOfPaymentProvider && props.showCreditCardForm)}
            onClick={() => props.toggleCreditCardForm(props.showCreditCardForm)}
        >
            {copyFor('buttons', 'backToPaymentType', 'donation', null)}
        </BackLink>
        <Disclaimer paymentMethod={props.paymentMethod} />
    </SidebarContainer>
);

Sidebar.propTypes = {
    amount: PropTypes.string.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    partnerLogo: PropTypes.string,
    showCreditCardForm: PropTypes.bool.isRequired,
    hasChoiceOfPaymentProvider: PropTypes.bool.isRequired,
    onPartnerClick: PropTypes.func,
    toggleCreditCardForm: PropTypes.func.isRequired
};

export default Sidebar;
